// Product page - mobile-only behaviour (<= 749px). Pairs with
// component-product-mobile.css:
//   1. moves the wishlist button onto the product image
//   2. subscription widget: "Subscribe & save" header + frequency chips
//   3. floating one-time add-to-cart bar
(function () {
  var mobileQuery = window.matchMedia('(max-width: 1239px)');

  // ---- 1. Wishlist button -> image ---------------------------------------
  function initWishlist() {
    var block = document.querySelector('.product__action-row .Vtl-AppBlock');
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    if (!block || !mediaWrapper) return;

    var home = block.parentNode;
    var marker = document.createComment('wishlist-home');
    home.insertBefore(marker, block);

    function place() {
      if (mobileQuery.matches) {
        if (block.parentNode !== mediaWrapper) mediaWrapper.appendChild(block);
      } else if (block.parentNode !== home) {
        home.insertBefore(block, marker.nextSibling);
      }
    }

    // Keep the heart inside the first slide, not over the "peek" of the next one.
    function alignToSlide() {
      var slide = mediaWrapper.querySelector('.product__media-item');
      if (!slide || !mobileQuery.matches) return;
      var wrapperRect = mediaWrapper.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      if (!slideRect.width) return;
      var right = Math.max(0, wrapperRect.right - slideRect.right) + 6;
      mediaWrapper.style.setProperty('--mobile-wishlist-right', right + 'px');
    }

    place();
    alignToSlide();
    mobileQuery.addEventListener('change', function () {
      place();
      alignToSlide();
    });
    window.addEventListener('resize', alignToSlide);
    window.addEventListener('load', alignToSlide);
  }

  // ---- 2. Subscription widget ---------------------------------------------
  function shortFrequency(label) {
    // "Deliver every month, 10% off" / "Deliver every 2 months, 7% off"
    var m = /every\s*(\d+)?\s*(day|week|month|year)s?\b[^%\d]*?(\d+)\s*%/i.exec(label || '');
    if (!m) return null;
    var n = m[1] ? parseInt(m[1], 10) : 1;
    var unit = m[2].toLowerCase();
    var adverb = { day: 'Daily', week: 'Weekly', month: 'Monthly', year: 'Yearly' }[unit];
    var abbr = { day: 'day', week: 'wk', month: 'mo', year: 'yr' }[unit];
    return {
      title: n === 1 ? adverb : 'Every ' + n + ' ' + abbr,
      percent: parseInt(m[3], 10),
    };
  }

  function setText(el, text) {
    if (el.textContent !== text) el.textContent = text;
  }

  function buildSubHead(group) {
    var head = document.createElement('div');
    head.className = 'mobile-sub-head';
    head.setAttribute('role', 'button');
    head.setAttribute('tabindex', '0');
    head.innerHTML =
      '<span class="mobile-sub-head__box" aria-hidden="true"></span>' +
      '<span class="mobile-sub-head__body">' +
      '<span class="mobile-sub-head__title"><span>Subscribe &amp; save</span><em class="mobile-sub-head__badge"></em></span>' +
      '<span class="mobile-sub-head__note">Auto-renews, skip or cancel anytime</span>' +
      '</span>' +
      '<span class="mobile-sub-head__price"></span>';

    function select() {
      var plans = group.querySelectorAll('input[data-radio-type="selling_plan"]');
      if (!plans.length || group.querySelector('input[data-radio-type="selling_plan"]:checked')) return;
      plans[0].click();
    }
    head.addEventListener('click', select);
    head.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        select();
      }
    });

    group.insertBefore(head, group.querySelector('.group_list'));
    group.classList.add('has-mobile-sub-head');
    return head;
  }

  // The app renders one widget per variant (only the selected variant's is
  // visible), so every subscription group gets handled on its own.
  function syncGroup(group) {
    var plans = group.querySelectorAll('input[data-radio-type="selling_plan"]');
    if (!plans.length) return;

    var head = group.querySelector('.mobile-sub-head') || buildSubHead(group);
    var maxPercent = 0;

    plans.forEach(function (plan) {
      var item = plan.closest('.group_list_item');
      if (!item) return;
      var info = shortFrequency(plan.getAttribute('aria-label'));
      if (!info) return;
      maxPercent = Math.max(maxPercent, info.percent);
      if (item.dataset.chipTitle !== info.title) item.dataset.chipTitle = info.title;
      var save = '-' + info.percent + '%';
      if (item.dataset.chipSave !== save) item.dataset.chipSave = save;
    });

    setText(head.querySelector('.mobile-sub-head__badge'), maxPercent ? '-' + maxPercent + '%' : '');
    head.querySelector('.mobile-sub-head__badge').hidden = !maxPercent;

    var active = group.querySelector('input[data-radio-type="selling_plan"]:checked') || plans[0];
    setText(head.querySelector('.mobile-sub-head__price'), (active.dataset.variantPrice || '').trim());
  }

  function syncSubscription(container) {
    container.querySelectorAll('.subscription_group').forEach(syncGroup);
  }

  function initSubscription() {
    var container = document.querySelector('.shopify_subscriptions_app_container');
    if (!container) return;

    var queued = false;
    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        syncSubscription(container);
      });
    }

    syncSubscription(container);
    container.addEventListener('change', schedule);
    new MutationObserver(schedule).observe(container, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-variant-price', 'aria-label'],
    });
  }

  // ---- 3. Floating one-time add-to-cart bar -------------------------------
  function initSticky() {
    var bar = document.querySelector('.mobile-sticky-atc');
    if (!bar) return;

    var dataEl = bar.querySelector('[data-sticky-variants]');
    var variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var currency = bar.dataset.currency || 'USD';
    var formatter;
    try {
      formatter = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });
    } catch (e) {
      formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    }
    function money(cents) {
      return formatter.format(cents / 100);
    }

    // The option holding plain whole numbers (20 / 50 / 100 ...) is the set size.
    var setIndex = -1;
    if (variants.length) {
      for (var i = 0; i < variants[0].options.length; i++) {
        var allNumeric = variants.every(function (v) {
          return /^\d+$/.test(v.options[i]);
        });
        if (allNumeric) {
          setIndex = i;
          break;
        }
      }
    }

    var labelEl = bar.querySelector('[data-sticky-label]');
    var eachEl = bar.querySelector('[data-sticky-each]');
    var priceEl = bar.querySelector('[data-sticky-price]');
    var submit = bar.querySelector('.product-form__submit');
    var qtyInput = bar.querySelector('.mobile-sticky-atc__qty-input');
    var idInputs = bar.querySelectorAll('input[name="id"]');
    var current = null;

    function qty() {
      var n = parseInt(qtyInput.value, 10);
      return n > 0 ? n : 1;
    }

    function render() {
      if (!current) return;
      var setSize = setIndex > -1 ? parseInt(current.options[setIndex], 10) : 0;
      setText(labelEl, setSize ? 'Set ' + setSize : current.title);
      setText(eachEl, setSize ? money(current.price / setSize) + '/ea' : '');
      setText(priceEl, money(current.price * qty()));
      idInputs.forEach(function (input) {
        input.value = current.id;
      });
      if (current.available) submit.removeAttribute('disabled');
      else submit.setAttribute('disabled', 'disabled');
      bar.classList.toggle('is-unavailable', !current.available);
      updateVisibility();
    }

    function setVariant(id) {
      var found = variants.filter(function (v) {
        return String(v.id) === String(id);
      })[0];
      if (!found) return;
      current = found;
      render();
    }

    var initialId = idInputs[0] && idInputs[0].value;
    setVariant(new URLSearchParams(window.location.search).get('variant') || initialId);

    // quantity stepper
    bar.querySelectorAll('.mobile-sticky-atc__qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var next = btn.name === 'plus' ? qty() + 1 : Math.max(1, qty() - 1);
        qtyInput.value = next;
        render();
      });
    });
    qtyInput.addEventListener('change', function () {
      qtyInput.value = qty();
      render();
    });

    // theme variant picker
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant) setVariant(variant.id);
      });
    }

    // visible once the main buy button has scrolled out of view (upwards)
    var mainButton = document.getElementById(bar.dataset.mainSubmit);
    var pastMainButton = false;

    function updateVisibility() {
      var show = mobileQuery.matches && pastMainButton && current && current.available;
      bar.classList.toggle('is-visible', !!show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('has-sticky-atc', !!show);
      if (show) document.documentElement.style.setProperty('--sticky-atc-h', bar.offsetHeight + 'px');
    }

    if (mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[entries.length - 1];
        pastMainButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateVisibility();
      }).observe(mainButton);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          pastMainButton = window.scrollY > 600;
          updateVisibility();
        },
        { passive: true }
      );
    }
    mobileQuery.addEventListener('change', updateVisibility);
  }

  function init() {
    initWishlist();
    initSubscription();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
